import type { PromotedBundleEdge } from '@/@types/graphql-types';
import type { FastOfferFragment, TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';

export const enum BuyboxOfferCategory {
	STREAM = 'stream',
	RENT = 'rent',
	BUY = 'buy',
	PHYSICAL = 'physical',
	BUNDLE = 'bundle',
	CINEMA = 'cinema',
}

export type TitleOffers = {
	stream: TitleOfferFragment[];
	buy: TitleOfferFragment[];
	rent: TitleOfferFragment[];
	free: TitleOfferFragment[];
	fast: FastOfferFragment[];
	cinema: TitleOfferFragment[];
	bundles?: PromotedBundleEdge[];
	offerCount: number;
	maxOfferUpdatedAt: string;
};
